import clsx from 'clsx'
import { Price } from './Price'

import { useBadges } from '@/components/snippets/badge/use-badge'
import { usePromoLines } from '@/components/snippets/promo-line/use-promo-lines'

import { ResultImage } from './ResultImage'
import { ResultsSwatches } from './ResultSwatches'
import { useSwatches } from '../hooks/useSwatches'
import { useBeaconLogClick } from '../hooks/useBeaconAnalytics'
import { Badge } from '@/components/snippets/badge/badge-render'
import { PromoLine } from '@/components/snippets/promo-line/render-promo-line'
import { ProductWishlist } from './ProductWishlist'
import { scrollHistoryManager } from '@/components/helpers/scroll-history'

export function ResultsCard({ result, className, wishlist, pageType, query, index }) {
  if (!result.images?.length > 0) return null
  const { omneoWishlists, offlineWishlistItems, wsCallbacks, type: wishlistType } = wishlist || {}

  const { currentResult, updateSwatch } = useSwatches(result)
  const criteria = {
    tags: currentResult?.tags ?? [],
    productIds: [currentResult.id],
    collectionIds: currentResult.collection_id
  }
  const badges = useBadges(criteria)
  const promoLines = usePromoLines(criteria)

  // Max 2 flags per card: one of each when both badges and promolines match,
  // otherwise up to 2 of whichever type is present
  const visibleBadges = badges.slice(0, promoLines.length ? 1 : 2)
  const visiblePromoLines = promoLines.slice(0, badges.length ? 1 : 2)

  const [variant] = currentResult.variants

  const clickLogger = useBeaconLogClick()

  // Analytics handling
  const handleLogClick = (e) => {
    let collectionState = ''
    if (typeof collection !== 'undefined') {
      collectionState = collection
    }
    // Collection is a global pulled from template-search.liquid and collection-grid.liquid. Ensure value is set in both places :)
    scrollHistoryManager.updateHistoryStateWithCollectionInfo(pageType, currentResult, collectionState, query)
    clickLogger(currentResult)
  }

  // This is wrapped in an extra div to support injection from Wishlist KING
  // DONT REMOVE THAT DIV 🔫
  return (
    <div className={clsx('group/card relative', className)} id={`result__${result.handle}`}>
      <div className="flex flex-col w-full h-full">
        <div className="relative overflow-hidden aspect-1 shrink-0">
          <a href={currentResult.url} onClick={handleLogClick} data-dl-track="select_item" data-dl-product-id={currentResult.uid} data-dl-index={index}>
            <ResultImage result={currentResult}>
              <div className="flex flex-col px-3 py-3 md:px-6 md:py-6">
                {visibleBadges.map((badge) => (
                  <Badge key={badge.text} badge={badge} badgeLocation="PLP" product={currentResult} />
                ))}
                {visiblePromoLines.map((promoLine) => (
                  <PromoLine key={promoLine.title} promoline={promoLine} />
                ))}
              </div>
            </ResultImage>
          </a>

          {(!wishlist?.type || wishlist?.type !== 'none') &&
            <ProductWishlist
              wishlist={{ omneoWishlists, offlineWishlistItems }}
              wsCallbacks={wsCallbacks}
              result={result}
              type={wishlistType}
            />
          }
        </div>
        <div className="flex flex-col justify-between flex-grow h-full gap-3 p-4 md:px-0 md:py-6">
          <div className="flex flex-col h-full gap-2">
            <p className="font-bold paragraph-sm" dangerouslySetInnerHTML={{ __html: currentResult.brand }} />
            <a className="paragraph-md" href={currentResult.url} data-dl-track="select_item" data-dl-product-id={currentResult.uid} data-dl-index={index} dangerouslySetInnerHTML={{ __html: currentResult.mfield_utopia_customer_facing_product_name }} />
          </div>
          <hr className="h-px bg-neutrals-light-grey" />
          <div className="flex justify-between">
            <Price price={variant.price} compareAtPrice={variant?.compare_at_price} />
            <ResultsSwatches result={currentResult} swatches={result.swatches} onSelectSwatch={updateSwatch} />
          </div>
        </div>
      </div>
    </div>
  )
}
